import { takeEvery, fork } from 'redux-saga/effects';
import { notification } from 'ui';

let notificationIds = [];
export function* watchFetchNotification() {
  yield takeEvery('SHOW_NOTIFICATION', (action) => {
    const { type, ...rest } = action.payload;
    notification[type](rest);
    if (rest?.key) {
      notificationIds.push(rest?.key);
    }
  });
}

export function* watchClearNotifications() {
  yield takeEvery('CLEAR_NOTIFICATIONS', () => {
    if (notificationIds.length) {
      notificationIds.forEach(notificationId => notification.destroy(notificationId));
      notificationIds = [];
    }
  });
}

export default [fork(watchFetchNotification), fork(watchClearNotifications)];
